<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      class="full-width"
      type="table"
    ></v-skeleton-loader>
    <TabbedDataTable v-else :tabs="tabs" @exportItems="exportItems"/>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import { format, fromUnixTime, getUnixTime, subYears, addYears, isBefore } from 'date-fns';
import TabbedDataTable from '@/components/common/TabbedDataTable.vue';
import { contentTypeSessions } from '../../../helpers/amplify';
import { downloadCSV } from '../../../helpers/utils';

export default {
  components: { TabbedDataTable },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const loading = ref(false);
    
    const pastSessions = ref([]);
    const futureSessions = ref([]);

    const headers = ref([
      { text: 'Session', value: 'name', align: 'center', sortable: true },
      { text: 'Date', value: 'date', align: 'center', sortable: true },
      { text: 'Heure de début', value: 'start', align: 'center', sortable: true },
      { text: 'Cavalier', value: 'participant', align: 'center', sortable: true }
    ]);

    const computeSession = (session) => {
      const participant = session.participants.find(p => p.horse === props.horse.uuid);
      return {
        name: session.name,
        date: format(fromUnixTime(session.start_time), 'yyyy/MM/dd'),
        start: format(fromUnixTime(session.start_time), 'HH:mm'),
        participant: participant ? `${participant.lastname} ${participant.firstname}` : '--'
      };
    };

    const tabs = ref([
    {
        index: 0,
        name: 'Historique',
        headerLabel: 'Historique d\'activité du cheval',
        headerButtons: [
          {
            plain: true,
            iconName: 'mdi-export',
            emitName: 'exportItems'
          }
        ],
        tableHeaders: headers.value,
        tableData: pastSessions.value,
        tableHeight: '350px',
        itemsPerPage: 10,
        sortBy: 'date',
        sortDesc: true,
      },
      {
        index: 1,
        name: 'Planning',
        headerLabel: 'Planning des chevaux',
        headerButtons: [
          {
            plain: true,
            iconName: 'mdi-export',
            emitName: 'exportItems'
          }
        ],
        tableHeaders: headers.value,
        tableData: futureSessions.value,
        tableHeight: '350px',
        itemsPerPage: 10,
        sortBy: 'date',
        sortDesc: true,
      }
    ]);

    const exportItems = ({tabIndex}) => {
      downloadCSV([{ headers: headers.value, data: tabs.value[tabIndex].tableData || [] }], `${tabs.value[tabIndex].headerLabel} - ${props.horse.horse_name}`);
    };

    onMounted(async () => {
      loading.value = true;
      const now = new Date();
      const start = getUnixTime(subYears(now, 1));
      const end = getUnixTime(addYears(now, 1));

      const sessions = await contentTypeSessions(props.horse, start, end);

      (sessions || []).forEach(session => { 
        if (isBefore(new Date(session.start_time * 1000), now)) {
          pastSessions.value.push(computeSession(session));
        } else {
          futureSessions.value.push(computeSession(session));
        }
      });

      loading.value = false;
    });

    return { headers, tabs, loading, exportItems };
  }
};
</script>
